import * as React from 'react';
import {OpenImageViewProps} from '../../../types/mx/components';

class OpenImageView extends React.Component<OpenImageViewProps, {}> {

    constructor(props) {
        super(props);
    }

    render() {
        const {imageUrl} = this.props;
        return (
            <div className="row">
                <div className="col">
                    <img src={imageUrl} className="img-fluid" alt="image"/>
                </div>
            </div>
        );
    }
}

export default OpenImageView;
